<template>
  

  <div class="grid" >
    <div class="col-12 md-12 lg-12">
      <HizliIslemler />
    </div>

    <div class="col-12 md-12 lg-12">
      <Bilgiler />
    </div>

    <div class="col-12 md-12 lg-12">
      <!-- <SatisGrafik /> -->
    </div>

  </div>


</template>

<script>
// import GlobalServis from "../../../services/GlobalServis";
import HizliIslemler from "./SubComponents/HizliIslemler.vue";
import Bilgiler from "./SubComponents/Bilgiler.vue";
// import SatisGrafik from "./SubComponents/SatisGrafik.vue";
export default {
  data() {
    return {
    };
  },
  methods: {

  },
  mounted() {
    
  },
  components: {
    HizliIslemler,
    Bilgiler,
    // SatisGrafik
  },
};
</script>
